import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import defaultFilters from '../../../constants/searchFilters'

const state = {
  savedSearches: [],
  studyDetails: {
    metadata: [],
    fragrance_details: [],
    tags: []
  },
  analytics: {
    metrics: {},
    performance: {},
    attributes: {},
    tendencies: {}
  },
  analyticsJobIds: {
    metrics: '',
    metricsAnalytic: '',
    metricsXLSX: '',
    performance: '',
    performanceXLSX: '',
    attributes: '',
    attributesXLSX: '',
    tendencies: '',
    tendenciesXLSX: '',
    significance: ''
  },
  studyMapping: [],
  studyCount: 0,
  fields: [],
  summaries: [],
  fragrances: [],
  concepts: [],
  cics: [],
  files: {
    report: [],
    RDF: [],
    questionnaire: [],
    protocol: [],
    screener: []
  },
  significance: {
    results: []
  },
  filterValues: defaultFilters.getInitialFilters(),
  cicsFilterValues: defaultFilters.getCicsFilters()
}

export default {
  namespaced: false,
  state,
  actions,
  getters,
  mutations
}
